import React from "react";

const DashboardFunnel = ({ items = [], onSelect, moneyFormatter }) => {
  if (!items.length) {
    return <div className="dashboard-empty">Sin estados para el periodo seleccionado.</div>;
  }

  const max = Math.max(...items.map((item) => Number(item.cantidad || 0)), 1);

  return (
    <div className="dashboard-funnel">
      {items.map((item) => {
        const width = Math.max(28, (Number(item.cantidad || 0) / max) * 100);
        return (
          <button
            type="button"
            key={item.estadoId}
            className="dashboard-funnel__row"
            onClick={() => onSelect?.(item)}
          >
            <div className="dashboard-funnel__label">
              <div>
                <span className="dashboard-funnel__state">{item.estado}</span>
                <span className="dashboard-funnel__count">{item.cantidad}</span>
              </div>
              <span className="dashboard-funnel__amount">{moneyFormatter(item.monto)}</span>
            </div>
            <div className="dashboard-funnel__track">
              <span style={{ width: `${width}%` }} />
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default DashboardFunnel;
